import { useEffect, useState } from 'react';
import services from '../../services';
import { useSelector } from 'react-redux';
import { selectSelectedCountryCode, selectSelectedCurrency } from '../../store/user';
// import ProductBox from '../components/categories/productBox';
import WidgetHome from '../../components/widgets/widgetHomeOrdered';
import ProductBox from '../../components/general/productBox';
import { Helmet } from 'react-helmet-new';
import SeoData from '../../utils/seo.json';
import NewHelmetLayout from '../../components/general/newHelmetLayout';

const AllAppeals = () => {
  const [products, setProducts] = useState();
  const selectedCurrencyStore = useSelector(selectSelectedCurrency);
  const [selectedCurrency, setSelectedCurrency] = useState();
  const selectedcountryCode = useSelector(selectSelectedCountryCode);
  const seo = SeoData[selectedcountryCode];
  /* ------------------------------ Start methods ----------------------------- */
  const notDisplayedCategories = ['Qurban'];
  // Excluded specific product names
  const excludedSpecificProductNames = ['Student Sponsorship', 'Student / Individual Sponsorship', 'Family Sponsorship'];

  // Helper function to check if a product should be included
  const isProductIncluded = product => {
    const excludedProductNames = ['Iftar', 'Afghanistan', 'Morocco', 'Turkiye'];
    const excludedProductDescriptions = ['Iftar', 'Afghanistan', 'Morocco', 'Turkiye', 'Türkiye'];
    return (
      !product.name.startsWith('Year') &&
      !excludedSpecificProductNames.includes(product.name) &&
      !excludedProductNames.some(name => product.name.includes(name)) &&
      !excludedProductDescriptions.some(description => product.description.includes(description))
    );
  };

  const getProducts = async () => {
    try {
      const response = await services.allProducts();
      let filteredCategories = response.data.filter(
        item => item.name && !['Undefined', 'Zakat', 'Eid Al Adha Gifts', 'General', 'Ramadan', 'Part Payments', 'Morocco'].includes(item.name),
      );

      let filteredSubCategories = filteredCategories.map(category => ({
        ...category,
        sub_categories: category.sub_categories
          .filter(
            sub => sub.name && !['Undefined', 'Zakat', 'Eid Al Adha Gifts', 'General', 'Libya Floods', 'Afghanistan', 'Morocco'].includes(sub.name),
          )
          .map(sub => ({
            ...sub,
            products: sub.products.filter(isProductIncluded),
          })),
      }));

      setProducts(filteredSubCategories);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  /* -------------------------------------------------------------------------- */
  /* ------------------------------- Start hooks ------------------------------ */
  useEffect(() => {
    getProducts();
    window.scroll(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    selectedCurrencyStore ? setSelectedCurrency(selectedCurrencyStore) : setSelectedCurrency('AUD');
  }, [selectedCurrencyStore]);
  /* -------------------------------------------------------------------------- */
  return (
    <NewHelmetLayout>
      {seo && (
        <Helmet>
          <title>{`${seo['appeals']['title']}`}</title>
          <link rel="canonical" href={`${window.location.protocol}//${window.location.host.replace(/^www\./i, "")}${window.location.pathname}`}/>
          <meta name="description" content={`${seo['appeals']['description']}`} />
        
          <link rel="alternate" href={`https://matwproject.org.uk${window.location.pathname}`} hreflang="en-gb" />
          <link rel="alternate" href={`https://matwproject.org${window.location.pathname}`} hreflang="x-default" />
          <link rel="alternate" href={`https://matwprojectca.org${window.location.pathname}`} hreflang="en-ca" />
          <link rel="alternate" href={`https://matwproject.org/fr${window.location.pathname}`} hreflang="fr-fr" />
          <link rel="alternate" href={`https://matwprojectusa.org${window.location.pathname}`} hreflang="en-us" />
          <link rel="alternate" href={`https://matwprojectid.org${window.location.pathname}`} hreflang="en-id" />
          <link rel="alternate" href={`https://matwprojectmys.org${window.location.pathname}`} hreflang="en-my" />
          <link rel="alternate" href={`https://matwprojectsgp.org${window.location.pathname}`} hreflang="en-sg" />
        </Helmet>
      )}
      <WidgetHome selectedCurrency={e => setSelectedCurrency(e.value)} />
      <div className="md:container md:mx-auto mt-5">
        <div className="grid grid-cols-12 px-4 md:px-2 lg:px-0">
          <div className=" col-start-1 col-span-12 rounded-md ">
            <div>
              {products ? (
                products.map(item => (
                  <div className="w-full " key={`allappeals${item.id}`}>
                    <h1 className="w-full text-center text-7xl text-[#253b7e] py-2  font-['Gotcha'] mt-6">
                      {item?.name === 'Sadaqah Jariyah' ? 'Sadaqah' : !notDisplayedCategories.includes(item.name) ? item.name : ''}
                    </h1>
                    {item.sub_categories.length > 0 ? (
                      <div className="grid grid-cols-1 ">
                        {item.sub_categories.map(subItem => (
                          <div key={`subItem.id${subItem.id}`} className="basis-1/2 sm:basis-1/3 md:basis-1/4 xl:basis-1/4">
                            <h1 className="w-full text-center text-5xl text-[#253b7e] py-2 md:pb-8 font-['Gotcha'] my-6">{subItem?.name}</h1>
                            <div className="flex justify-center flex-wrap">
                              {subItem.products?.map(prod => {
                                // prod.name === 'Pakistan Solar Powered Well' && console.log("prod",prod)
                                return (
                                  Number(prod.status) === 1 &&
                                  prod.name !== 'Pakistan Solar Powered Well' && (
                                    <div className="basis-1/2 sm:basis-1/3 md:basis-1/3 xl:basis-1/4 p-2" key={prod.id}>
                                      {/* <ProductBox forAppeals product={prod} currency={selectedCurrency}/> */}
                                      <ProductBox product={prod} currency={selectedCurrency} />
                                    </div>
                                  )
                                );
                              })}
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <> </>
                    )}
                  </div>
                ))
              ) : (
                <div role="status" className="w-full flex justify-center items-center min-h-[500px]">
                  <svg
                    aria-hidden="true"
                    className="w-20 h-20 mr-2 text-gray-200 animate-spin fill-[#00a3da]"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"
                    />
                  </svg>
                  <span className="sr-only">Loading...</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </NewHelmetLayout>
  );
};

export default AllAppeals;
